import React from 'react';

// Small segmented Full / Compact toggle that lives in each calculator header,
// right next to the Settings gear. Quick access, takes no extra row.
const MODES = [
  { key: 'full', label: 'Full' },
  { key: 'compact', label: 'Compact' },
];

const ViewModeToggle = ({ viewMode = 'full', onChange }) => (
  <div
    role="tablist"
    aria-label="View mode"
    className="flex gap-1 shrink-0"
  >
    {MODES.map(({ key, label }) => {
      const active = viewMode === key;
      return (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange && onChange(key)}
          className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors ${
            active
              ? 'text-slate-200 bg-slate-700/80 shadow-[inset_0_0_0_1px_rgba(255,255,255,0.08)]'
              : 'text-slate-500 hover:text-slate-300'
          }`}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default ViewModeToggle;
